import {
    createRegisterableComponentWithData,
    PublicationType,
    SubscriptionOfferLoader,
} from '@news-mono/web-common'
import React from 'react'
import { useSectionMetaInfo } from '../../__helpers'
import { RegionalsSwgPromoPageProps } from './RegionalsSwgPromoPage'
import { LazyRegionalsSwgPromoPage } from './RegionalsSwgPromoPage.lazy'

type RegionalsSwgPromoPage = Omit<
    RegionalsSwgPromoPageProps,
    'onEvent' | 'publication' | 'sectionMeta' | 'initialOfferData'
>
export const RegionalsSwgPromoPageRegistration =
    createRegisterableComponentWithData(
        'regionals-swg-promo-page',
        SubscriptionOfferLoader,
        (props: RegionalsSwgPromoPage, data, services) => {
            const sectionMeta = useSectionMetaInfo()

            const publication: PublicationType = {
                kind: 'article',
                byline: 'Campaign',
                source: 'Subscribe with Google',
                slug: 'subscribewithgoogle',
                heading: `Subscribe with Google Campaign ${sectionMeta.Title}`,
                content: [],
                canonicalTitle: `Subscribe with Google Campaign ${sectionMeta.Title}`,
                canonicalUrl: '',
                layoutView: 'default',
                requiredAccess: {
                    level: 'subscriber',
                },
                excludeFeaturedVideo: false,
                allowCommenting: false,
                hideMainImage: false,
                _self: '',
                id: '',
                homepageHead: undefined,
                socialHead: undefined,
                teaser: undefined,
                socialTeaser: undefined,
                publicationDate: '',
                isSponsored: false,
                hasOovvuuRecommendations: false,
                homepageTeaser: '',
                primaryTopic: {
                    id: '',
                    title: '',
                    seoTitle: '',
                    metadata: {},
                },
                secondaryTopics: [],
            }

            return (
                <LazyRegionalsSwgPromoPage
                    title={props.title}
                    description={props.description}
                    image={props.image}
                    productId={props.productId}
                    onEvent={services.onEvent}
                    publication={publication}
                    sectionMeta={sectionMeta}
                    options={props.options}
                    logger={props.logger}
                    initialOfferData={data.loaded ? data.result : undefined}
                />
            )
        },
    )
